import React from 'react';

export const RecommendContents = () => {
  const stockRecommend = [
    {
      titile: '高配当株',
      message: <>憧れの配当生活を実現したい</>,
      explanation: (
        <>
          ・預貯金の利息では満足できない
          <br />
          ・値上がりを待つだけではなく定期的に現金収入も欲しい
        </>
      ),
      img: 'haito',
      link:
        'https://minkabu.jp/discover/haito?utm_source=tw_minkabu&utm_medium=portfolio_analysis&utm_campaign=discover_haito_202304',
    },
    {
      titile: '割安株',
      message: <>値下がりリスクを抑えて長期投資</>,
      explanation: (
        <>
          ・安心して長期投資できる銘柄を探している
          <br />
          ・キャピタルゲインに加えインカムゲインも
        </>
      ),
      img: 'nenkin',
      link:
        'https://minkabu.jp/discover/nenkin?utm_source=tw_minkabu&utm_medium=portfolio_analysis&utm_campaign=discover_nenkin_202304',
    },
    {
      titile: '優待株',
      message: (
        <>
          株主優待を楽しみながら
          <br />
          資産を形成したい
        </>
      ),
      explanation: (
        <>
          ・目先の株価にとらわれず長期で運用したい
          <br />
          ・食料品・金券等がもらえる彩りのある生活
        </>
      ),
      img: 'yutai',
      link:
        'https://minkabu.jp/discover/yutai?utm_source=tw_minkabu&utm_medium=portfolio_analysis&utm_campaign=discover_yutai_202304',
    },
  ];

  return (
    <>
      <div className="mt-2 mb-4 border-t"></div>
      <div className="mx-4">
        <div className="font-bold">個別銘柄に興味がある方へ</div>
        <div className="text-xs mb-4">
          みんかぶ株式よりおすすめコンテンツをご紹介。
        </div>
      </div>
      {stockRecommend.map((item, i) => (
        <div className="mx-4 mb-4" key={i}>
          <a href={item.link} target="_blank" rel="noopener noreferrer">
            <div
              className="rounded-lg border border-bluegray-300 bg-white grid"
              style={{ gridTemplateColumns: '1fr auto' }}>
              <div className="py-3 pl-3 pr-2">
                <div className="flex flex-row items-center">
                  <div>
                    <img
                      src={`/static/images/advisor/${item.img}.svg`}
                      className=""
                      alt={`${item.titile}`}
                    />
                  </div>
                  <div className="font-bold">
                    <div className="text-lg">{item.titile}</div>
                    <div className="text-xs text-bluegray-500">
                      {item.message}
                    </div>
                  </div>
                </div>
                <div className="pt-4">
                  <div className="flex flex-row items-center">
                    <img
                      src={`/static/images/advisor/hukidashi.svg`}
                      className=""
                      alt="吹き出し"
                    />
                    <div className="ml-1 text-sm font-bold">
                      こんな方におすすめ
                    </div>
                  </div>
                  <div className="pt-1 text-xs">{item.explanation}</div>
                </div>
              </div>
              <div
                className={`flex rounded-r-lg flex-row items-center icon-chevron-right text-2xl font-bold text-bluegray-400 bg-bluegray-60 border-l border-bluegray-300`}></div>
            </div>
          </a>
        </div>
      ))}
      <div className="mt-2 mb-4 border-t"></div>
      <div className="mx-4">
        <div className="flex flex-row items-center">
          <div>
            <img
              src={`/static/images/advisor/screening.svg`}
              className=""
              alt="こだわり条件で探す"
            />
          </div>
          <div className="font-bold">こだわり条件で探す</div>
        </div>
        <div className="text-xs my-1">
          銘柄スクリーニング機能がご利用いただけます。こだわりの条件で、あなただけの銘柄を見つけられます。
        </div>
        <a
          href="https://minkabu.jp/stock/search?utm_source=tw_minkabu&utm_medium=portfolio_analysis&utm_campaign=stock_search_202304"
          target="_blank"
          rel="noopener noreferrer">
          <button className="w-full mb-4 border-bluegray-400 border rounded-lg shadow bg-bluegray-100 flex flex-row items-center justify-center py-2 px-4 text-base font-bold">
            銘柄を探す
          </button>
        </a>
      </div>
      <div className="mt-2 mb-2 border-t"></div>
    </>
  );
};
